module.exports = __webpack_public_path__ + "static/media/ea-logo@2x.16c0fdea.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/ea-logo@2x.png
// module id = 296
// module chunks = 0